import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";


function persianNumber(string) {
    return string.split("0").join("۰")
        .split("1").join("۱")
        .split("2").join("۲")
        .split("3").join("۳")
        .split("4").join("۴")
        .split("5").join("۵")
        .split("6").join("۶")
        .split("7").join("۷")
        .split("8").join("۸")
        .split("9").join("۹");
}


export default class Footer extends Component {
    render() {
        return (
            <footer id="public-footer">
                <div className="top dr-padding">
                    <div className="logo-container">
                        <a referrerpolicy='origin' target='_blank'
                           href='https://trustseal.enamad.ir/u?id=392751&code=4sNnLliyIOKWkMg8UxYceDzQu1GXQFLi'>
                            <img referrerpolicy='origin'
                                 src='https://trustseal.enamad.ir/logo.aspx?id=392751&code=4sNnLliyIOKWkMg8UxYceDzQu1GXQFLi'
                                 alt='' style={{cursor:"pointer"}} code='4sNnLliyIOKWkMg8UxYceDzQu1GXQFLi'/>
                        </a>
                        <img
                            src="/images/amir_logo.jpg"
                            className="logo1"
                            alt=""
                        />
                        <img
                            src="/images/logo-footer.svg"
                            className="logo2"
                            alt=""
                        />


                    </div>
                    <div className="info">
                        <h4 className="title">آکادمی درایت</h4>
                        {/* <p className="subtitle">
                            همکار آموزشی دانشگاه صنعتی شریف
                        </p> */}
                    </div>
                    <div className="contact">
                        <ul>
                            <li className="center">
                                <span className="tell" onClick={e => {
                                    document.location.href = `tel:02166089773`;
                                }}> ۶۶۰۸۹۷۷۳ ۰۲۱</span>
                                <span className="tell-2" onClick={e => {
                                    document.location.href = `tel:02166089773`;
                                }}>۰۲۱ ۶۶۰۸۹۷۷۳ </span>
                                <span className="icon icon-dr-tell"></span>
                            </li>
                            <li className="rsp">
                                <span>support@derayatacademy.com</span>
                                <span className="icon icon-dr-email"></span>
                            </li>
                        </ul>
                    </div>
                    {/*<div className="enamad-link">*/}
                    {/*<a target="_blank" href="https://trustseal.enamad.ir/?id=121053&amp;Code=1lQ7pnwBkr6z7aU8arRH"><img src="https://Trustseal.eNamad.ir/logo.aspx?id=121053&amp;Code=1lQ7pnwBkr6z7aU8arRH" style={{cursor: "pointer", height: "90px", zIndex: 1000, position:"relative"}} alt="" id="1lQ7pnwBkr6z7aU8arRH"/></a>*/}
                    {/*</div>*/}
                </div>
                <div className="bottom dr-padding">
                    <div className="social-res">
                        <a href="https://www.instagram.com/mba_amirkabir/" target="_blank">
                            <img src="/images/instagram.svg" alt="instagram"/>
                        </a>
                        <a href="https://t.me/Mba_amirkabir" target="_blank">
                            <img src="/images/telegram.svg" alt="telegram"/>
                        </a>
                        <a href="https://www.linkedin.com/company/derayatacademy/" target="_blank">
                            <img src="/images/linkedin.svg" alt="linkedin"/>
                        </a>
                    </div>
                    <div className="copyright">
                        تمامی حقوق برای شرکت ارزش آفرینان هوشمند شریف محفوظ است.
                        ©
                    </div>

                    <ul className="left">
                        <li>
                            <Link to="/rules/1">قوانین و مقررات</Link>
                        </li>
                        <li>
                            <Link to="/rules/2">حریم خصوصی</Link>
                        </li>
                        <span> ما را دنبال کنید </span>
                        <a href="https://www.instagram.com/mba_amirkabir/" target="_blank">
                            <img src="/images/instagram.svg" alt="instagram"/>
                        </a>
                        <a href="https://t.me/Mba_amirkabir" target="_blank">
                            <img src="/images/telegram.svg" alt="telegram"/>
                        </a>
                        <a href="https://www.linkedin.com/company/derayatacademy/" target="_blank">
                            <img src="/images/linkedin.svg" alt="linkedin"/>
                        </a>
                    </ul>


                </div>
            </footer>
        );
    }
}
